import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { UPGRADE_STATUS, FLAG_LABELS } from '../../constants/upgrades';

export function StatusBadge({ status }) {
  const s = UPGRADE_STATUS[status] || { label: status, bg: '#eee', color: '#333' };
  return <span className="upg-badge" style={{ background: s.bg, color: s.color }}>{s.label}</span>;
}

// Attention flags computed by the server (expired quote, follow-up, waiting for a date, overdue…)
export function FlagChips({ flags = [], hide = [] }) {
  const shown = flags.filter((f) => !hide.includes(f) && FLAG_LABELS[f]);
  return shown.map((f) => (
    <span key={f} className={`upg-flag ${f === 'starts_soon' || f === 'unscheduled' ? 'upg-flag--info' : ''}`}>
      <AlertTriangle size={12} aria-hidden="true" /> {FLAG_LABELS[f]}
    </span>
  ));
}
